import { QH_AUTH_API_URL } from 'config';
import { LSL_CLIENT_ID, OAUTH_REDIRECT_ROUTE, OAUTH_STATE } from 'config/constants';
import useOAuth from 'hooks/useOAuth';
import useQueryParams from 'hooks/useQueryParams';
import { FC, useEffect } from 'react';
import { useHistory } from 'react-router';

import LoadingPage from 'pages/LoadingPage';
import { GA } from 'types';
import sendGAEvent from 'utils/sendGAEvent';

const AuthPage: FC = () => {
  const history = useHistory();
  const query = useQueryParams();
  const code = query.get('code');
  const state = query.get('state');
  const { logout } = useOAuth();

  useEffect(() => {
    const handle = async () => {
      const savedState = window.sessionStorage.getItem(OAUTH_STATE);
      const savedRedirectRoute = window.sessionStorage.getItem(OAUTH_REDIRECT_ROUTE);
      const redirectRoute = savedRedirectRoute?.startsWith('/') ? savedRedirectRoute : '/';

      if (!state || !savedState || decodeURIComponent(state) !== savedState || !code) {
        return history.replace(redirectRoute);
      }

      try {
        const url = new URL(`${QH_AUTH_API_URL}/callback`);
        url.searchParams.append('code', code);
        url.searchParams.append('state', state);
        url.searchParams.append('client_id', LSL_CLIENT_ID);
        const response = await fetch(url.toString(), { credentials: 'include' });
        if (!response.ok) {
          throw new Error(`Error status: ${response.status}`);
        }

        const responseData = await response.json();

        sendGAEvent({
          type: GA.EventType.LOGIN,
          points: responseData.qff_points,
          method: GA.AuthMethod.OAUTH,
        });
      } catch (error) {
        await logout({ lslOnly: true });
      }

      history.replace(redirectRoute);
    };

    handle();
  }, [code, history, logout, state]);

  return <LoadingPage />;
};

export default AuthPage;
